import { createElement } from 'react'
import { ics as icsFn } from 'calendar-link'

import { CalAppleIcon } from '@pleio/icons/cal-apple'
import { CalIcalIcon } from '@pleio/icons/cal-ical'

import { type CalendarEvent } from '../CalendarEvent'
import { type DownloadCalendarLink } from '../CalendarLink'
import descriptionAsText from '../descriptionAsText'
import escapeICS from '../escapeIcs'
import icsFilename from '../icsFilename'
import normalizeLocation from '../normalizeLocation'

export default function ics(
    label: string,
    ariaLabel?: string,
): (event: CalendarEvent) => DownloadCalendarLink {
    return function icsLink(event: CalendarEvent): DownloadCalendarLink {
        return {
            label,
            'aria-label': ariaLabel,
            download: icsFilename(event.start, event.title),
            url: icsFn({
                start: event.start,
                end: event.end,
                title: event.title,
                description: descriptionAsText(event),
                location: escapeICS(normalizeLocation(event)),
                url: event.eventPageUrl,
            }),
            iconBefore:
                label === 'Apple'
                    ? createElement(CalAppleIcon)
                    : createElement(CalIcalIcon),
        }
    }
}
